import { apiValidateTemporaryPassword } from '../services';
export async function validateTemporaryPassword(email, password) {
    const response = await apiValidateTemporaryPassword(email, password);
    return formatResponse(response);
}
function formatResponse({ success }) {
    if (!success) {
        return { success: false };
    }
    return { success: true };
}
